import React from "react";

export const RepCustomersContext = React.createContext<{repCustomersData?: any, updateRepCustomersData: (data: any) => void}>({
    repCustomersData: undefined,
    updateRepCustomersData: (data: any) => {},
  });